import {
  AlertVariant,
  useAlert,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Alert';
import { Button } from '@mui/material';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';

const Sandbox: React.FC = () => {
  const [, { openAlert }] = useAlert();
  const handleClick = () => {
    openAlert({
      body: 'TEST',
      variant: AlertVariant.SUCCESS,
    });
  };
  return (
    <>
      <SectionHeader title={'Sandbox'} />
      <Button onClick={handleClick}>openAlert</Button>
    </>
  );
};

export default Sandbox;
